module.exports = __webpack_public_path__ + "img/2019_Xingyi.f7665494.png";